import { useQuery } from "@tanstack/react-query";
import { AssignedCompaniesListItem } from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { companiesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

export const ACTION_GET_ASSIGNED_COMPANIES = "GET_ASSIGNED_COMPANIES";

const getAssignedCompanies = async (): Promise<AssignedCompaniesListItem[]> => {
  const response = await companiesApi.companiesControllerGetAssignedCompanies();

  return response.data;
};

export const useGetAssignedCompanies = (): {
  assignedCompanies: AssignedCompaniesListItem[] | undefined;
  refetchAssignedCompanies: () => void;
  isPendingGetAssignedCompanies: boolean;
  isSuccessGetAssignedCompanies: boolean;
} => {
  const { data, isPending, isSuccess, refetch } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_ASSIGNED_COMPANIES],
    queryFn: getAssignedCompanies,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled: !!localStorage.getItem("access_token"),
  });

  return {
    assignedCompanies: data,
    refetchAssignedCompanies: refetch,
    isPendingGetAssignedCompanies: isPending,
    isSuccessGetAssignedCompanies: isSuccess,
  };
};
